import React from 'react';

export default () => <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd"
        d="M11.7515 25.9108L0.000244141 13.9601L3.00324 11.5381L9.80374 16.8668C12.581 13.5611 18.7602 6.97235 27.2792 1.75035L28.0002 3.41285C20.1777 10.6053 13.7727 20.7308 11.7515 25.9108Z"
        fill="#2A4D8F"/>
  <mask id="mask0" masktype="alpha" maskUnits="userSpaceOnUse" x="0" y="1" width="29" height="25">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M11.7515 25.9108L0.000244141 13.9601L3.00324 11.5381L9.80374 16.8668C12.581 13.5611 18.7602 6.97235 27.2792 1.75035L28.0002 3.41285C20.1777 10.6053 13.7727 20.7308 11.7515 25.9108Z"
          fill="white"/>
  </mask>
  <g mask="url(#mask0)">
    <rect y="-1.52588e-05" width="28" height="28" fill="#48A100"/>
  </g>
</svg>
